import Vue from 'vue'
import dayjs from 'dayjs'

Vue.directive('time_format', {
  bind: function (el, binding) {
    el.innerHTML = dayjs(binding.value).format('YYYY-MM-DD')
  }
})

Vue.directive('time_format2', {
  bind: function (el, binding) {
    el.innerHTML = dayjs(binding.value).format('YYYY-MM')
  }
})

Vue.directive('time_format3', {
  bind: function (el, binding) {
    el.innerHTML = dayjs(binding.value).format('YYYY-MM-DD HH:mm:ss')
  }
})

Vue.directive('boolean_chinese', {
  bind: function (el, binding) {
    el.innerHTML = binding.value === true ? '是' : '否'
  }
})

Vue.directive('role_chinese', {
  bind: function (el, binding) {
    switch (binding.value) {
      case 'admin':
        el.innerHTML = '管理员'
        break
      case 'editor':
        el.innerHTML = '商户'
        break
      default:
        el.innerHTML = '其他'
    }
  }
})

Vue.directive('machine_status_chinese', {
  bind: function (el, binding) {
    if (binding.value) {
      el.innerHTML = '正在充电'
    } else {
      el.innerHTML = '无充电'
    }
  }
})

Vue.directive('electric_record_status_chinese', {
  bind: function (el, binding) {
    switch (binding.value) {
      case 'started':
        el.innerHTML = '正在充电'
        break
      case 'stopped':
        el.innerHTML = '已停止'
        break
      case 'unlocked':
        el.innerHTML = '已解锁'
        break
      default:
        el.innerHTML = '其他'
    }
  }
})
